import { render, staticRenderFns } from "./GjwDialog.vue?vue&type=template&id=11154894&scoped=true"
import script from "./GjwDialog.vue?vue&type=script&lang=js"
export * from "./GjwDialog.vue?vue&type=script&lang=js"
import style0 from "./GjwDialog.vue?vue&type=style&index=0&id=11154894&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11154894",
  null
  
)

export default component.exports